import { render } from "./SubscriptionPrompt.vue?vue&type=template&id=67d9f8b4"
import script from "./SubscriptionPrompt.vue?vue&type=script&lang=js"
export * from "./SubscriptionPrompt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__